import { render, staticRenderFns } from "./province.vue?vue&type=template&id=7450deb3"
import script from "./province.vue?vue&type=script&lang=js"
export * from "./province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports